import { BreakpointSize, JoykitColor } from '@components/themes';
import { MarcomStyledComponentsProps } from '@components/MarcomThemeProvider';
import { getColumnGap } from '@components/Columns';
import { columnGapsMap } from '@components/Columns/Columns.styles';

export const themeColor = (color: JoykitColor) => ({ theme }: MarcomStyledComponentsProps) => theme.colors[color];
export const themeSpace = (space: number) => ({ theme }: MarcomStyledComponentsProps) => {
  let result = theme.space[Math.abs(space)];
  if (space < 0) {
    result = `-${result}`;
  }
  return result;
};
export const themeMediaQuery = (breakpointSize: BreakpointSize) => ({ theme }: MarcomStyledComponentsProps) =>
  theme.mediaQueries[breakpointSize];

export const themeColumnWidth = (breakpointSize: Exclude<BreakpointSize, 'below_sm'>, columnsPerRow: number) => ({
  theme,
}: MarcomStyledComponentsProps) => {
  const { rootFontSize } = theme.global;
  const columnGap = columnGapsMap[breakpointSize];
  // * 2 as both left and right columns have paddings on sides
  const columnsPadding = Number.parseFloat(getColumnGap(theme, columnGap)) * rootFontSize * 2;
  const maxInnerWidth = theme.maxColumnsWidths[breakpointSize];

  // Inner gutters are not collapsed, so we'll
  return `${(maxInnerWidth - columnsPadding * (columnsPerRow - 1)) / rootFontSize / columnsPerRow}rem`;
};
